import React, { useEffect, useRef, useState } from "react";
import AdRenderer from "./AdRendererOptimize";
import AccessSuccess from "./AccessSuccess";
import AccessFail from "./AccessFail";
import "../styles/animations.css";
import axios from "axios";
import { pathAPI, pathLoginPortal } from "../utils/pathAPI";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import LanguageSwitcher from "./LanguageSwitcher";
import { useIntl } from "react-intl"; // Sử dụng useIntl thay vì useTranslation
import { Call, Sms } from "iconsax-react";
import { decodeAllParams, encodeAllParams } from "../utils/query";
import settings, { ENV } from "../settings";
import { getTrackingQueue } from "../utils/trackingQueue";
interface AdSettings {
  id: number;
  ad_type?:
    | "banner"
    | "video1"
    | "video2"
    | "survey"
    | "app"
    | "3rd_party"
    | "survey2";
  image_url?: string;
  image_tablet_url?: string;
  image_desktop_url?: string;
  video_url?: string;
  banner_url?: string;
  logo_img_url?: string;
  button_text?: string;
  button_color?: string;
  background_color?: string;
  destination_url?: string;
  destination_url_tablet?: string;
  destination_url_desktop?: string;
  non_skip?: number;
  one_click?: string;
  fullname?: string;
  template_name: string;
  phone_number?: string;
  email?: string;
  BoD?: string;
  gender?: string;
  app_store_url?: string;
  ch_play_url?: string;
  google_analytics_key?: string;
  is_enable_3rd_party?: string;
  impression_tag_3rd_party_image?: string;
  impression_tag_3rd_party_iframe?: string;
  impression_tag_3rd_party_js?: string;
  impression_tag_3rd_party_click?: string;
  type_optional_answer?: string;
  optional_answer?: string;
  optional_question?: string;
  is_otp_enable?: string;
  is_optional_question?: string;
  is_optional_question_1?: string;
  optional_answer_1?: string;
  optional_question_1?: string;
  type_optional_answer_1?: string;
  optional_answer_2?: string;
  optional_question_2?: string;
  type_optional_answer_2?: string;
  footer_email?: string;
  footer_phone?: string;
  layout_num?: number;
  rating_title?: string;
  rating_score?: string;
}

const CaptivePortal: React.FC = () => {
  const [adSettings, setAdSettings] = useState<AdSettings | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [accessStatus, setAccessStatus] = useState<
    "none" | "success" | "failed"
  >("none");

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const hasPageLoad = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const originalParamsRef = useRef<Record<string, any>>({}); // Lưu tham số gốc (chưa mã hóa)
  const intl = useIntl(); // Sử dụng useIntl để lấy hàm formatMessage

  // Cập nhật URL và lưu tham số gốc khi component mount
  // useEffect(() => {
  //   if (!hasPageLoad.current) {
  //     // Lấy tham số từ location.search ban đầu
  //     const params = queryString.parse(location.search);
  //     console.log({ params });
  //     const initialParams: Record<string, string> = {};

  //     // Kiểm tra xem query string đã mã hóa hay chưa
  //     const ssidName = params.ssidName
  //       ? Array.isArray(params.ssidName)
  //         ? params.ssidName.join("")
  //         : params.ssidName
  //       : "";
  //     const isAlreadyEncrypted = isEncrypted(ssidName);
  //     console.log({ isAlreadyEncrypted });

  //     if (isAlreadyEncrypted) {
  //       // Nếu đã mã hóa, giải mã để lấy giá trị gốc
  //       for (const [key, value] of Object.entries(params)) {
  //         const val = Array.isArray(value) ? value.join("") : value || "";
  //         try {
  //           initialParams[key] = decryptAES(decodeURIComponent(val));
  //         } catch (error) {
  //           initialParams[key] = val; // Nếu giải mã thất bại, sử dụng giá trị gốc
  //         }
  //       }
  //     } else {
  //       // Nếu chưa mã hóa, lưu giá trị gốc trực tiếp
  //       for (const [key, value] of Object.entries(params)) {
  //         initialParams[key] = Array.isArray(value)
  //           ? value.join("")
  //           : value || "";
  //       }
  //     }

  //     console.log({ initialParams });

  //     // Lưu tham số gốc vào useRef
  //     originalParamsRef.current = initialParams;

  //     // Mã hóa query string và cập nhật URL
  //     const sanitizedParams: Record<string, string | string[]> =
  //       Object.fromEntries(
  //         Object.entries(params).map(([key, value]) => [
  //           key,
  //           Array.isArray(value)
  //             ? value.filter((v): v is string => v !== null)
  //             : value ?? "",
  //         ])
  //       );
  //     const newQueryString = encodeQueryString(sanitizedParams);
  //     navigate(`${location.pathname}?${newQueryString}`, { replace: true });
  //     hasPageLoad.current = true;

  //     // Gọi loadAdSettings ngay sau khi lưu tham số gốc
  //     loadAdSettings();
  //   }
  // }, []); // Dependency rỗng để chỉ chạy một lần khi mount

  useEffect(() => {
    if (!hasPageLoad.current) {
      const params = queryString.parse(location.search);
      if (params.d) {
        // Giải mã tất cả tham số gốc
        const decodedParams = decodeAllParams();
        originalParamsRef.current = decodedParams;
      } else {
        // Chưa có d → gom toàn bộ param vào d
        const encoded = encodeAllParams(params);
        navigate(`${location.pathname}?${encoded}`, { replace: true });
        originalParamsRef.current = params;
      }
      hasPageLoad.current = true;
      loadAdSettings();
    }
  }, []);

  const handleRecordLogin = async (
    type: string,
    loginStatus: string,
    loginFailedReason: string,
    adId: number,
    loginType: string,
    isOtp?: boolean,
  ) => {
    const params = originalParamsRef.current || {};
    const { ipAddressClient, ipAddressNAS, macAddressClient, macAddressNAS } =
      getLoginParams(params);
    const recordApiUrl = `${process.env.REACT_APP_BACKEND_URL_TEST + pathAPI.recordAccess}`;
    const submitAccess = {
      type,
      macAddressNAS,
      ipAddressNAS,
      ipAddressClient,
      macAddressClient,
      loginStatus,
      loginFailedReason,
      adId,
      loginType,
      isOtp,
    };
    try {
      await axios.post(`${recordApiUrl}`, submitAccess, {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
          "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
          "Access-Control-Allow-Headers": "Content-Type, Authorization",
        },
      });
    } catch (error) {
      // console.log(error);
    }
  };

  // google_analytics_key là UTM parameters string, không phải GA tracking ID
  // Không cần initialize ReactGA ở đây nữa

  const mapRuckusParams = (params: any) => {
    return {
      clientMac: params.client_mac || null,
      clientIp: params.uip || null,
      apMac: params.mac || null,
      ssidName: params.ssid || params.wlanName || null,
      originUrl: params.url ? decodeURIComponent(params.url) : null,
      authType: 2,
      scheme: null,
      target: params.nbiIP || null,
      targetPort: null,
      loginPath: null,
    };
  };

  const mapDefaultParams = (params: any) => {
    return {
      clientMac: params.clientMac || null,
      clientIp: params.clientIp || null,
      apMac: params.apMac || null,
      ssidName: params.ssidName || null,
      originUrl: decodeURIComponent(params.originUrl || null),
      authType: 2,
      scheme: params.scheme || null,
      target: params.target || null,
      targetPort: params.targetPort || null,
      loginPath: pathLoginPortal.tplink,
    };
  };

  const isRuckusPayload = (params: any) => {
    // Kiểm tra xem có phải request từ Ruckus không
    return (
      params &&
      (params.client_mac || params.apip || params.ssid || params.zoneName)
    );
  };

  const getWifiParams = (params: any) => {
    const isRuckus = isRuckusPayload(params);

    return {
      ssidName: isRuckus
        ? params.ssid || params.wlanName || null
        : params.ssidName || null,
      apMac: isRuckus ? params.mac || null : params.apMac || null,
    };
  };

  const getLoginParams = (params: any) => {
    const isRuckus = isRuckusPayload(params);

    return {
      macAddressNAS: isRuckus ? params.mac || null : params.apMac || null,
      ipAddressNAS: isRuckus ? params.sip || null : params.target || null,
      ipAddressClient: isRuckus ? params.uip || null : params.clientIp || null,
      macAddressClient: isRuckus
        ? params.client_mac || null
        : params.clientMac || null,
    };
  };

  const loadAdSettings = async () => {
    const params = originalParamsRef.current || {};
    const adApiUrl = `${process.env.REACT_APP_BACKEND_URL_TEST + pathAPI.loadConfigAd}`;
    //console.log("originalParams (decoded):", originalParamsRef.current);

    const currentDate = new Date();
    const currentTime = `${currentDate.getHours().toString().padStart(2, "0")}:${currentDate.getMinutes().toString().padStart(2, "0")}:${currentDate.getSeconds().toString().padStart(2, "0")}`;

    // Lấy giá trị ssidName từ originalParamsRef (đã lưu giá trị gốc)
    const { ssidName, apMac } = getWifiParams(params);

    const queryParams = new URLSearchParams({
      ssid: ssidName,
      currentDate: currentTime,
      apMac,
    }).toString();

    try {
      const response = await axios.get(`${adApiUrl}?${queryParams}`);
      const data = response.data;
      setAdSettings(data.data || null);
      if (data.data && data.data.id !== undefined) {
        handleRecordLogin("record_access", "", "", data.data.id, "");
      }
    } catch (error) {
      setErrorMessage("Không thể tải quảng cáo. Vui lòng thử lại sau.");
      setAdSettings(null);
    } finally {
      setIsLoading(false);
    }
  };

  const doSubmit = async () => {
    setIsLoading(true);
    const submitUrl = `${process.env.REACT_APP_BACKEND_URL_TEST + pathAPI.doSubmitAccess}`;
    const submitData = isRuckusPayload(originalParamsRef.current)
      ? mapRuckusParams(originalParamsRef.current)
      : mapDefaultParams(originalParamsRef.current);
    // Bật khi demo
    // setIsLoading(false);
    // setAccessStatus("success");

    try {
      const response = await axios.post(submitUrl, submitData, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
          "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
          "Access-Control-Allow-Headers": "Content-Type, Authorization",
        },
      });
      const data = response.data;
      if (data.errorCode === 0) {
        // Success - End tracking with success status
        await endUserSession("success");

        setAccessStatus("success");
        if (adSettings && adSettings.ad_type !== "survey2") {
          handleRecordLogin(
            "record_login",
            "success",
            errorHintMap[data.errorCode],
            adSettings?.id,
            "one_click",
            false,
          );
        }
      } else {
        // Failed - End tracking with failed status
        await endUserSession("failed", errorHintMap[data.errorCode]);

        setErrorMessage(errorHintMap[data.errorCode] || "Lỗi không xác định");
        setAccessStatus("failed");
        if (
          adSettings &&
          adSettings.id !== undefined &&
          adSettings.ad_type !== "survey2"
        ) {
          handleRecordLogin(
            "record_login",
            "fail",
            errorHintMap[data.errorCode],
            adSettings.id,
            "one_click",
            false,
          );
        }
      }
    } catch (error) {
      // Error - End tracking with error status
      await endUserSession("error", String(error));

      setErrorMessage(intl.formatMessage({ id: "error.connectionFailed" }));
      setAccessStatus("failed");
      if (
        adSettings &&
        adSettings.id !== undefined &&
        adSettings.ad_type !== "survey2"
      ) {
        handleRecordLogin(
          "record_login",
          "fail",
          String(error),
          adSettings.id,
          "one_click",
          false,
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to end user session tracking
  const endUserSession = async (
    status: "success" | "failed" | "error",
    errorMessage?: string,
  ) => {
    try {
      const trackingQueue = getTrackingQueue();
      if (trackingQueue) {
        // Manually track session_end event with session_end timestamp and session_duration
        const sessionEndTimestamp = new Date().toISOString();
        const sessionStart = Date.now() - performance.now(); // Estimate session start
        const sessionDuration = Math.floor((Date.now() - sessionStart) / 1000);

        trackingQueue.track("user_session_end", {
          status,
          errorMessage: errorMessage || null,
          session_end: sessionEndTimestamp,
          session_duration: sessionDuration,
          adId: adSettings?.id,
          adType: adSettings?.ad_type,
          ssid: originalParamsRef.current.ssidName,
          macAddressClient: originalParamsRef.current.clientMac,
        });

        // Flush queue immediately
        await trackingQueue.flush();
      }
    } catch (error) {
      console.error("Failed to end user session tracking:", error);
    }
  };

  const doSubmitSurvey = async (dataSurvey: any) => {
    const params = originalParamsRef.current || {};
    const { ssidName, apMac } = getWifiParams(params);

    // đảm bảo không bị null
    params.apMac = apMac || null;
    params.gatewayMac = params.gatewayMac || null;

    const submitUrl = `${process.env.REACT_APP_BACKEND_URL_TEST + pathAPI.submitSurvey}`;
    //console.log("originalParams (decoded):", originalParamsRef.current);
    const surveyQuestion =
      dataSurvey?.optionalSurveyQuestion ||
      adSettings?.optional_question ||
      null;
    const surveyQuestion1 =
      dataSurvey?.optionalSurveyQuestion1 ||
      adSettings?.optional_question_1 ||
      null;
    const surveyQuestion2 =
      dataSurvey?.optionalSurveyQuestion2 ||
      adSettings?.optional_question_2 ||
      null;

    const ratingTitle =
      dataSurvey?.ratingTitle || adSettings?.rating_title || null;

    const submitData = {
      fullname: dataSurvey?.fullName,
      phoneNumber: dataSurvey?.phoneNumber,
      email: dataSurvey?.email,
      birthOfDate: dataSurvey?.birthdate,
      gender: dataSurvey?.gender,
      ssid: ssidName,
      macAddressNAS: apMac,
      templateName: adSettings?.template_name,
      optionalSurveyQuestion: surveyQuestion,
      optionalSurveyAnswer: JSON.stringify(dataSurvey?.optionalSurveyAnswer),
      optionalSurveyQuestion1: surveyQuestion1,
      optionalSurveyAnswer1: JSON.stringify(dataSurvey?.optionalSurveyAnswer1),
      optionalSurveyQuestion2: surveyQuestion2,
      optionalSurveyAnswer2: JSON.stringify(dataSurvey?.optionalSurveyAnswer2),
      optionalSurveyAnsExtend: dataSurvey?.optionalSurveyAnsExtend,
      isSendOTP: dataSurvey?.isSendOTP,
      ratingTitle,
      ratingScore: +dataSurvey?.ratingScore,
    };

    try {
      const response = await axios.post(submitUrl, submitData, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
          "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
          "Access-Control-Allow-Headers": "Content-Type, Authorization",
        },
      });
      const data = response.data;
      if (data.code === 0) {
        if (adSettings?.ad_type === "survey2") {
          const isOtp = dataSurvey?.isSendOTP === "true";
          handleRecordLogin(
            "record_login",
            "success",
            errorHintMap[data.errorCode],
            adSettings?.id,
            "one_click",
            isOtp,
          );
        }
      }
    } catch (error) {
      if (adSettings?.ad_type === "survey2" && adSettings?.id !== undefined) {
        handleRecordLogin(
          "record_login",
          "fail",
          String(error) || "Network error",
          adSettings.id,
          "one_click",
          false,
        );
      }
      setErrorMessage(intl.formatMessage({ id: "error.connectionFailed" }));
    } finally {
    }
  };
  const handleRetry = () => {
    setAccessStatus("none");
    setErrorMessage(null);
  };

  const errorHintMap: { [key: string]: string } = {
    "-1": "Dịch vụ bị lỗi.",
    "-1001": "Invalid request parameters.",
    "-41506": "Invalid Authorization Information.",
    "-41500": "Invalid authentication type.",
    "-41501": "Xác thực thất bại.",
    "-41529": "Username hoặc Password không đúng.",
    "-41530": "Connecting to the RADIUS server times out.",
    "401": "Unauthorized access.",
    "403": "Access forbidden.",
    "404": "Resource not found.",
    "500": "Internal server error.",
  };

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
        <div className="relative flex items-center justify-center">
          <div className="w-24 h-24 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <img
            src={settings.loadingImg}
            alt="Company Logo"
            className="absolute object-contain w-16 h-16 rounded-lg bg-white p-3"
          />
        </div>
      </div>
    );
  }

  if (accessStatus === "success") {
    return (
      <AccessSuccess
        destinationUrl={adSettings?.destination_url || settings.destinationUrl}
        destinationUrlTablet={adSettings?.destination_url_tablet}
        destinationUrlDesktop={adSettings?.destination_url_desktop}
        isLoading={isLoading}
        googleAnalyticsKey={adSettings?.google_analytics_key}
      />
    );
  }

  if (accessStatus === "failed") {
    return (
      <AccessFail
        errorMessage={errorMessage || "Đã xảy ra lỗi không xác định"}
        onRetry={handleRetry}
      />
    );
  }

  return (
    <div
      className={`flex flex-col font-sans bg-gray-50 text-gray-800 h-screen overflow-hidden
    ${adSettings?.layout_num === 1 || !adSettings ? "" : ""}`}
    >
      {(adSettings?.layout_num === 1 || !adSettings) && (
        <header id="header" className="headerContainer relative z-50 h-[80px]">
          {/* Decorative bottom border */}
          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent"></div>
          <div className="flex items-center justify-between h-full">
            <div className="mr-2">
              <LanguageSwitcher />
            </div>
            <div className="flex flex-row gap-2">
              <img
                id="logoPartner"
                src={settings.logoPartner}
                alt="logo partner"
                className="max-h-[60px] h-auto object-contain"
                style={{
                  borderRadius: ENV === "staging" ? 0 : "12px",
                  maxHeight: 60,
                }}
              />
            </div>
          </div>
        </header>
      )}

      <div className="flex-1 overflow-x-hidden overflow-y-hidden">
        <AdRenderer
          adSettings={adSettings}
          macAddressClient={originalParamsRef.current.clientMac}
          onSubmit={doSubmit}
          onSubmitSurvey={doSubmitSurvey}
        />
      </div>

      {(adSettings?.layout_num === 1 || !adSettings) && (
        <footer
          className="relative z-50 bg-gradient-to-r from-slate-50 via-white to-slate-50 border-t border-gray-100 shadow-lg backdrop-blur-sm"
          id="footer"
        >
          {/* Decorative top border */}
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent"></div>

          <div className="container mx-auto px-4 py-4">
            <div className="flex flex-col xl:flex-row items-center justify-between space-y-3 xl:space-y-0 text-sm">
              {/* Contact Information */}
              <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-gray-700 font-medium">
                    {intl.formatMessage({ id: "footer.advertising" })}:
                  </span>
                </div>

                <div className="flex items-center justify-center flex-wrap space-x-3">
                  <a
                    href={`tel:+${adSettings?.footer_phone || "842838331106"}`}
                    className="group flex items-center space-x-1 text-primary hover:text-blue-700 transition-all duration-200 hover:scale-105"
                  >
                    <Call
                      size={18}
                      className="text-primary group-hover:text-blue-700"
                    />
                    <span className="group-hover:underline leading-[18px] whitespace-nowrap text-[13px] md:text-sm">
                      {adSettings?.footer_phone || "+(84.28) 38331106"}
                    </span>
                  </a>

                  <a
                    href={`mailto:${adSettings?.footer_email || "info@vtctelecom.com.vn"}`}
                    className="group flex items-center space-x-1 text-primary  hover:text-blue-700 transition-all duration-200 hover:scale-105"
                  >
                    <Sms
                      size={18}
                      className="text-primary group-hover:text-blue-700"
                    />
                    <span className="leading-[18px] group-hover:underline whitespace-nowrap text-[13px] md:text-sm">
                      {adSettings?.footer_email || "info@vtctelecom.com.vn"}
                    </span>
                  </a>
                </div>
              </div>

              {/* Powered by section */}
              <div className="flex items-center space-x-2">
                <span className="text-gray-600">
                  {intl.formatMessage({ id: "footer.poweredBy" })}
                </span>
                <div className="flex items-center space-x-1">
                  <strong className="text-gray-800 ">
                    ©{settings.poweredBy}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          {/* Subtle bottom glow */}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-px bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
        </footer>
      )}
    </div>
  );
};

export default CaptivePortal;
